import React from 'react';

const Ads = () => {
    return (
        <div className="ads">
            <div className="contents">
                <p className="aboutText">
                    Sneakers Never Run Out Of Style 
                    Get 50% Off Sitewide
                </p>
                <span className="shopping">
                    <a href="#">Start Shopping</a>
                </span>
            </div>
        </div>
    );
};

export default Ads;